import { jsx as _jsx } from "react/jsx-runtime";
import { ExternalLink, Text } from "@sundae/ui-toolkit";
const URL_RE = /(https?:\/\/[^\s;,)]+)/g;
/**
 * Renders an operator-supplied tentative/hold reason, linkifying any URLs it
 * contains so users can act on it (e.g. open the incident post or a support
 * ticket). Explains why a reward is under review / can't be claimed.
 */
const TentativeReason = ({ reason }) => {
    return (_jsx(Text, { size: "sm", tag: "p", variant: "muted", children: reason.split(URL_RE).map((part, i) => /^https?:\/\//.test(part) ? (_jsx(ExternalLink, { size: "sm", href: part, children: part }, i)) : (_jsx("span", { children: part }, i))) }));
};
export default TentativeReason;
//# sourceMappingURL=TentativeReason.js.map